module.exports = ".validatedIsbn {\n  text-align: center; }\n\n.switcher {\n  padding-left: 15px;\n  padding-bottom: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/views/add-isbn-view/add-isbn-view.component.scss
// module id = ./src/app/+app-custom/views/add-isbn-view/add-isbn-view.component.scss
// module chunks = main